import { render, staticRenderFns } from "./PointRulePopup.vue?vue&type=template&id=a6e48168&"
import script from "./PointRulePopup.vue?vue&type=script&lang=js&"
export * from "./PointRulePopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports